import { create } from 'zustand';

interface DiscoveryState {
  /** The currently selected city for homepage filtering. `null` means "All Locations". */
  selectedCity: string | null;
  /** Set the selected city. */
  setSelectedCity: (city: string | null) => void;
}

/**
 * useDiscoveryStore – manages global discovery filters like the selected location/city.
 * Subscribed to by the homepage and the navigation header.
 */
export const useDiscoveryStore = create<DiscoveryState>((set) => ({
  selectedCity: null, // Default to "All Locations"
  setSelectedCity: (city) => set({ selectedCity: city }),
}));
